/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_LanguagesInputs */

const en_resume_editor_languages = /** @type {(inputs: Resume_Editor_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Languages`)
};

const de_resume_editor_languages = /** @type {(inputs: Resume_Editor_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachen`)
};

const fr_resume_editor_languages = /** @type {(inputs: Resume_Editor_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langues`)
};

const es_resume_editor_languages = /** @type {(inputs: Resume_Editor_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idiomas`)
};

const it_resume_editor_languages = /** @type {(inputs: Resume_Editor_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingue`)
};

const nl_resume_editor_languages = /** @type {(inputs: Resume_Editor_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talen`)
};

const pl_resume_editor_languages = /** @type {(inputs: Resume_Editor_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jezyki`)
};

const fi_resume_editor_languages = /** @type {(inputs: Resume_Editor_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kielet`)
};

const da_resume_editor_languages = /** @type {(inputs: Resume_Editor_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprog`)
};

const sv_resume_editor_languages = /** @type {(inputs: Resume_Editor_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprak`)
};

/**
* | output |
* | --- |
* | "Languages" |
*
* @param {Resume_Editor_LanguagesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_languages = /** @type {((inputs?: Resume_Editor_LanguagesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_LanguagesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_languages(inputs)
	if (locale === "fr") return fr_resume_editor_languages(inputs)
	if (locale === "es") return es_resume_editor_languages(inputs)
	if (locale === "it") return it_resume_editor_languages(inputs)
	if (locale === "nl") return nl_resume_editor_languages(inputs)
	if (locale === "pl") return pl_resume_editor_languages(inputs)
	if (locale === "fi") return fi_resume_editor_languages(inputs)
	if (locale === "da") return da_resume_editor_languages(inputs)
	if (locale === "sv") return sv_resume_editor_languages(inputs)
	return en_resume_editor_languages(inputs)
});